import type { ComponentProps } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import { SelectTrigger } from "./SelectTrigger";
import { SelectValue } from "./SelectValue";
import { SelectContent } from "./SelectContent";
import { SelectItem } from "./SelectItem";
import { SelectGroup } from "./SelectGroup";
import { SelectLabel } from "./SelectLabel";
import { SelectSeparator } from "./SelectSeparator";
import { SelectButton } from "./SelectButton";

export type SelectProps = ComponentProps<typeof SelectPrimitive.Root>;

const SelectRoot = (props: SelectProps) => <SelectPrimitive.Root data-slot="select" {...props} />;

export const Select = Object.assign(SelectRoot, {
  Trigger: SelectTrigger,
  Value: SelectValue,
  Content: SelectContent,
  Item: SelectItem,
  Group: SelectGroup,
  Label: SelectLabel,
  Separator: SelectSeparator,
  Button: SelectButton,
});
